import React from 'react';

export default (props) => {
  const { handleToggle, faq, id, categoryID } = props;
  const { header, text } = faq;
  const handleClick = (event) => {
    event.preventDefault();
    const { target } = event;
    const ID = target.id.split('_');
    const btn = document.getElementById(`btnFAQ_${ID[1]}`);
    handleToggle(btn);
  };
  return (
    <article>
      <button
        id={`btnFAQ_${categoryID}${id}`}
        className="btnStyleFAQ"
        onClick={handleClick}
        aria-expanded={false}
      >
        <p
          id={`spanFAQ_${categoryID}${id}`}
          className="fontTitleStyleFAQ"
        >
          {header}
        </p>
        <span>
          <svg
            id={`svgFAQ_${categoryID}${id}`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M16.59 8.29492L12 12.8749L7.41 8.29492L6
              9.70492L12 15.7049L18 9.70492L16.59 8.29492Z"
              fill="#333333"
            />
          </svg>
        </span>
      </button>
      <div>
        <p
          className="fontStyleFAQ"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </div>
    </article>
  );
};
